import { books } from '../../data';
import './Books.css';

function Books({ onOpenModal }) {
  return (
    <section className="books-sec" id="books">
      <div className="cta-ring" />
      <div className="cta-ring" />

      <span className="books-pre rv">Our Books</span>
      <h2 className="books-h rv">Books by <em>Dr. Sunil Patel</em></h2>

      <div className="books-grid">
        {books.map((book, i) => (
          <div key={i} className="book-card rv">
            <img src={book.image} alt={book.title} className="book-img" />
            <div className="book-info">
              <h3>{book.title}</h3>
            </div>
          </div>
        ))}
      </div>

      <div className="books-cta rv">
        <a href="#" className="books-btn" onClick={(e) => { e.preventDefault(); onOpenModal(); }}>
          Get Your Free Copy{' '}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="5"  y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </a>
        <p className="books-cta-note">🔒 Free · No obligation · Delivered instantly</p>
      </div>
    </section>
  );
}

export default Books;
